import { render, staticRenderFns } from "./Lessons.vue?vue&type=template&id=48b64e83&scoped=true"
import script from "./Lessons.vue?vue&type=script&lang=js"
export * from "./Lessons.vue?vue&type=script&lang=js"
import style0 from "./Lessons.vue?vue&type=style&index=0&id=48b64e83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b64e83",
  null
  
)

export default component.exports